import axios from 'axios';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';

import config from '../../config/config';
import constant from '../../utils/Constant';
import Loader from '../partials/Loader';
import placeholder from '../../assets/images/1080.png'

const {
    EMPTY_STRING: emptyString,
    BOOLEAN_FALSE: falseValue,
    BOOLEAN_TRUE: trueValue,
    VIEW_VENDORS_END_POINT,
    UPDATE_BUSINES_DETAIL_END_POINT,
    DELETE_VENDOR_IMAGE_END_POINT,
    DELETE_SERVICE_IMAGE_END_POINT,
    STATUS_200,
    STATUS_401,
    LOGOUT,
    NULL,
    ZERO,
} = constant;

const UpdateVendor = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const vendorData = location.state?.vendor_id || '';

    const [vendorID] = useState(vendorData);
    const [loading, setLoading] = useState(falseValue);
    const [disableButton, setDisableButton] = useState(falseValue);
    const [confirmationModal, setConfirmationModal] = useState(falseValue);
    const [confirmationModal1, setConfirmationModal1] = useState(falseValue);
    const [imageID, setImageID] = useState(emptyString);
    const [serImg, setSerImg] = useState(emptyString);
    const [images, setImages] = useState([]);
    const [formData, setFormData] = useState({
        category: emptyString,
        title: emptyString,
        location: [],
        website: emptyString,
        priceMin: ZERO,
        priceMax: ZERO,
        description: emptyString,
        insta: emptyString,
        phone: emptyString,
        email: emptyString,
    });
    const [isStatus, setIsStatus] = useState({
        status: 0,
        availability_status: 0,
        is_featured: 0,
    })

    // * location array
    const locationArray = [
        'Eastern Cape', 'Free State',
        'Gauteng', 'KwaZulu-Natal',
        'Limpopo', 'Mpumalanga',
        'Northern Cape', 'North West',
        'Western Cape'
    ];

    const locationOptions = locationArray.map((loc) => ({
        value: loc,
        label: loc,
    }));

    const [services, setServices] = useState(vendorData.vendor_services || []);

    const fileInputRef = useRef(NULL);
    const confirmationRef = useRef(NULL);

    // * get token from local storage
    const token = localStorage.getItem('vendor_dashboard');

    // * execute vendor detaits api
    const executeAllVendorApi = useCallback(async () => {
        try {
            const apiUrl = `${config.appBaseUrl + VIEW_VENDORS_END_POINT}/${vendorID}`;

            // * execute get request
            const response = await axios.get(apiUrl, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // * api response
            const result = response.data;

            // * if response is success
            if (result.code === STATUS_200 && result.status) {
                const records = result.data;
                setFormData({
                    category: records.category,
                    title: records.name,
                    location: records.location,
                    website: records.website,
                    priceMin: records.min,
                    priceMax: records.max,
                    description: records.description,
                    insta: records.insta,
                    phone: records.phone,
                    password: records.password,
                    email: records.email,
                })
                setServices(records.vendor_services);
                setImages(records.vendor_images?.map(img => ({
                    file: null,
                    id: img.id,
                    preview: img.image
                })) || [])
                setIsStatus({
                    status: records.status,
                    availability_status: records.availability_status,
                    is_featured: records.is_featured,
                })
            }
        } catch (error) {
            // * if token is expired
            if (error.response?.data.code === STATUS_401) {
                navigate(LOGOUT);
            }
            toast.error(error);
        }
    }, [navigate, token, vendorID]);

    // * execute vendor detais api
    useEffect(() => {
        executeAllVendorApi();
    }, [executeAllVendorApi, token]);

    // * handle upload click
    const handleUploadClick = () => {
        fileInputRef.current.click();
    };

    // * handle image change
    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
        const maxSize = 2 * 1024 * 1024; // 2MB

        const newImages = [];
        let invalidTypeFound = false;
        let invalidSizeFound = false;

        files.forEach((file) => {
            if (!allowedTypes.includes(file.type)) {
                invalidTypeFound = true;
            } else if (file.size > maxSize) {
                invalidSizeFound = true;
            } else {
                newImages.push({
                    file,
                    preview: URL.createObjectURL(file),
                });
            }
        });

        if (invalidTypeFound) {
            toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed.");
        }
        if (invalidSizeFound) {
            toast.error("Each image must be 2MB or smaller.");
        }

        setImages((prevImages) => {
            const totalImages = prevImages.length + newImages.length;

            if (totalImages > 20) {
                toast.error("Maximum 20 images are allowed.");
                const allowedToAdd = 20 - prevImages.length;
                return [...prevImages, ...newImages.slice(0, allowedToAdd)];
            }

            return [...prevImages, ...newImages];
        });

        // ✅ Reset input to allow same file re-selection
        e.target.value = null;
    };

    // * handle change 
    const handleChange = (e, index, type) => {
        if (type === 'services' || type === 'tags') {
            const updatedList = [...formData[type]];
            updatedList[index] = e.target.value;
            setFormData({ ...formData, [type]: updatedList });
        } else {
            setFormData({ ...formData, [e.target.name]: e.target.value });
        }

        // * if category change then empty service and tags input 
        if (e.target.name === 'category') {
            setServices([]);
        }
    };

    // * service card validation
    const validateServices = () => {
        const isNameEmpty = services.some((service) => !service.service_name);
        const isImageEmpty = services.some((service) => service.image === placeholder);

        if (isNameEmpty) {
            toast.error("Service name is required.");
            return false;
        }

        if (isImageEmpty) {
            toast.error("Service image is required.");
            return false;
        }

        return true;
    };

    // * execute update vendor api
    const executeUpdateVendorApi = async () => {

        if (validateServices()) {

            // * set loading and disable button
            setLoading(trueValue);
            setDisableButton(trueValue);

            // * create form data
            const data = new FormData();
            data.append('profile', null);
            data.append('name', formData.title);
            data.append('description', formData.description);

            const locArray = JSON.stringify(formData.location.map(opt => opt));
            data.append('location', locArray);

            data.append('min', formData.priceMin);
            data.append('max', formData.priceMax);
            data.append('email', formData.email);
            data.append('phone', formData.phone);
            data.append('password', formData.password);
            data.append('insta', formData.insta);
            data.append('website', formData.website);
            data.append('is_featured', isStatus.is_featured);

            for (const [index, service] of services.entries()) {
                data.append(`service_price[${index}]`, service.price);
                data.append('service_name[]', service.service_name);
                data.append('service_id[]', service.id);

                if (service.isNew && service.image !== placeholder) {
                    try {
                        const response = await fetch(service.image);

                        if (!response.ok) {
                            throw new Error(`Failed to fetch image. Status: ${response.status}`);
                        }

                        const blob = await response.blob();
                        const file = new File([blob], `service_${service.service_id}.jpg`, { type: blob.type });
                        data.append(`service_image[${index}]`, file);
                    } catch (error) {
                        console.error("Error converting image to file:", error);
                        data.append(`service_image[${index}]`, null);
                    }
                }
                else if (!service.isNew && service.image) {
                    if (service.image.startsWith("blob:")) {
                        try {
                            const response = await fetch(service.image);
                            const blob = await response.blob();
                            const file = new File([blob], `service_${service.service_id}.jpg`, { type: blob.type });
                            data.append(`service_image[${index}]`, file);
                        } catch (error) {
                            console.error("Error converting blob to file:", error);
                            data.append(`service_image[${index}]`, null);
                        }
                    } else {
                        data.append(`service_image[${index}]`, service.image);
                    }
                }
                else {
                    data.append(`service_image[${index}]`, null);
                }
            }

            images.forEach((item) => {
                if (item.file instanceof File) {
                    data.append('business_images[]', item.file);
                }
            });

            data.append('id', vendorID);
            data.append('availability_status', isStatus.availability_status);
            data.append('status', isStatus.status);

            try {
                const apiUrl = `${config.appBaseUrl + UPDATE_BUSINES_DETAIL_END_POINT}`;

                // * execute put request
                const response = await axios.post(apiUrl, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                // * api response
                const apiResponse = response.data;

                // * if response is success
                if (apiResponse.code === STATUS_200 && apiResponse.status) {
                    toast.success(apiResponse.message);
                    setTimeout(() => {
                        navigate('/vendor/details')
                    }, 1500)
                }
            } catch (error) {
                handleError(error);
                // * if token is expired
                if (error.response?.data?.code === STATUS_401) {
                    navigate(LOGOUT);
                }
            } finally {
                setLoading(falseValue);
                setDisableButton(falseValue);
            }
        }
    };

    //* handle error
    const handleError = (error) => {
        const errorData = error.response?.data?.data;

        if (errorData && typeof errorData === 'object') {
            const firstKey = Object.keys(errorData)[0];
            const firstMessage = errorData[firstKey][0];
            toast.error(firstMessage);
        } else {
            toast.error('Something was broken!');
        }
    };

    // * execute delete image api
    const executeDeleteImageApi = async () => {

        setLoading(trueValue);
        setDisableButton(trueValue);

        try {
            const apiUrl = `${config.appBaseUrl + DELETE_VENDOR_IMAGE_END_POINT}/${imageID}`;

            //* post request
            const response = await axios.get(apiUrl,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            //* response success
            const result = response.data;
            if (result.code === STATUS_200 && result.status) {
                toast.success(result.message);
                executeAllVendorApi();
                setConfirmationModal(falseValue);
            } else {
                toast.error(result.message);
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message);

            // * if user is unauthorized
            if (error?.response?.data?.code === STATUS_401) {
                navigate(LOGOUT);
            }
        } finally {
            setDisableButton(falseValue);
            setLoading(falseValue);
        }
    };

    //* disable scroll
    useEffect(() => {
        if (confirmationModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [confirmationModal]);

    //* close modal when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (confirmationRef.current && !confirmationRef.current.contains(event.target)) {
                setConfirmationModal(falseValue);
            }
        };

        if (confirmationModal) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [confirmationModal, setConfirmationModal]);

    //* trap focus within modal when open
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Tab' && (confirmationModal)) {
                const focusableElements = confirmationRef.current.querySelectorAll('button, input, select, textarea, a');
                if (focusableElements.length === 0) return;

                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];

                //* prevent tabbing outside the modal
                if (event.shiftKey) {
                    if (document.activeElement === firstElement) {
                        lastElement.focus();
                        event.preventDefault();
                    }
                } else {
                    if (document.activeElement === lastElement) {
                        firstElement.focus();
                        event.preventDefault();
                    }
                }
            }
        };

        //* add event listener
        if (confirmationModal) {
            document.addEventListener('keydown', handleKeyDown);
        } else {
            document.removeEventListener('keydown', handleKeyDown);
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [confirmationModal]);

    // * handle add service
    const handleAddService = () => {
        const newService = {
            id: Date.now(),
            image: placeholder,
            price: 0,
            service: '',
            service_id: 0,
            isNew: true,
            index: 0, // Set the index to 0 since it's the first item now
        };

        // Update the index for existing services
        const updatedServices = services.map((service, idx) => ({
            ...service,
            index: idx + 1, // Shift each index by 1
        }));

        setServices([...updatedServices, newService]);
    };

    //* handle file change
    const handleFileChange = (e, id) => {
        const updatedServices = services.map((service) => {
            if (service.id === id) {
                return { ...service, image: URL.createObjectURL(e.target.files[0]) };
            }
            return service;
        });
        setServices(updatedServices);
    };

    //* handle input change
    const handleInputChange = (e, id, field) => {

        let value = e.target.value;

        if (field === 'service') {
            value = parseInt(value, 10);
            if (isNaN(value)) {
                value = 0;
            }
        }

        const updatedServices = services.map((service) => {
            if (service.id === id) {
                return { ...service, [field]: value };
            }
            return service;
        });

        setServices(updatedServices);
    };

    //* Remove Service
    const handleRemoveService = (id) => {
        const updatedServices = services.filter(service => service.id !== id);
        setServices(updatedServices);
    };

    // * execute delete service image api
    const executeDeleteServiceImageApi = async () => {

        setLoading(trueValue);
        setDisableButton(trueValue);

        try {
            const apiUrl = `${config.appBaseUrl + DELETE_SERVICE_IMAGE_END_POINT}/${serImg}`;

            //* post request
            const response = await axios.get(apiUrl,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            //* response success
            const result = response.data;
            if (result.code === STATUS_200 && result.status) {
                toast.success(result.message);
                executeAllVendorApi();
                setConfirmationModal1(falseValue);
            } else {
                toast.error(result.message);
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message);

            // * if user is unauthorized
            if (error?.response?.data?.code === STATUS_401) {
                navigate(LOGOUT);
            }
        } finally {
            setDisableButton(falseValue);
            setLoading(falseValue);
        }
    };

    return (
        <>
            <ToastContainer autoClose={1000} position='top-center' />

            {/* //* delete image model */}
            {confirmationModal && (
                <>
                    <div className='modal-backdrop fade show'></div>
                    <div
                        id='user_logout_modal'
                        className='modal fade show'
                        style={{ display: 'block' }}
                    >
                        <div className='modal-dialog'>
                            <div className='modal-content' ref={confirmationRef}>
                                <div className='modal-body'>
                                    <p className='mb-0'>Are you sure you want to delete this image?</p>
                                </div>
                                <div className='modal-footer me-2 border-top-0'>
                                    <button
                                        type='button'
                                        className='btn btn-danger text-white'
                                        data-dismiss='modal'
                                        onClick={() => setConfirmationModal(falseValue)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type='button'
                                        className='btn btn-success text-white'
                                        onClick={executeDeleteImageApi}
                                        disabled={disableButton}
                                    >
                                        {!loading ? 'Confirm' : <Loader />}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {/* //* delete image model */}
            {confirmationModal1 && (
                <>
                    <div className='modal-backdrop fade show'></div>
                    <div
                        id='user_logout_modal'
                        className='modal fade show'
                        style={{ display: 'block' }}
                    >
                        <div className='modal-dialog'>
                            <div className='modal-content' ref={confirmationRef}>
                                <div className='modal-body'>
                                    <p className='mb-0'>Are you sure you want to delete this service image?</p>
                                </div>
                                <div className='modal-footer me-2 border-top-0'>
                                    <button
                                        type='button'
                                        className='btn btn-danger text-white'
                                        data-dismiss='modal'
                                        onClick={() => setConfirmationModal1(falseValue)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type='button'
                                        className='btn btn-success text-white'
                                        onClick={executeDeleteServiceImageApi}
                                        disabled={disableButton}
                                    >
                                        {!loading ? 'Confirm' : <Loader />}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            <div className='page-content px-4' style={{ zIndex: '1' }}>
                <div className='container-fluid'>
                    {/* //* start page title */}
                    <div className='row'>
                        <div className='col-12 px-0'>
                            <div className='page-title-box d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-2'>
                                <h4 className='mb-2 mb-sm-0'>Edit</h4>

                                <div className='page-title-right'>
                                    <ol className='breadcrumb m-0 d-flex flex-wrap gap-1'>
                                        <li className='breadcrumb-item'>
                                            <Link to='/dashboard'>Dashboard</Link>
                                        </li>
                                        <li className='breadcrumb-item active pointer' onClick={() => navigate(-1)}>Business Details</li>
                                        <li className='breadcrumb-item active'>Edit</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-xl-12'>
                        <div className='card'>
                            <div className='card-body'>
                                <div className='row'>

                                    {/* //* busines information */}
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center justify-content-between rounded-2 mb-3 px-3 py-2" style={{ background: '#e8fff4' }}>
                                                    <label htmlFor="email" className="mb-0 fw-semibold">Business Information</label>
                                                </div>
                                                <div className="row">
                                                    {/* //* category */}
                                                    <div className='col-12 col-md-12 col-lg-6 col-xl-4 col-xxl-3 mb-3'>
                                                        <label htmlFor='category'>Category</label>
                                                        <select
                                                            name='category'
                                                            id='category'
                                                            className='form-control m-0 font-size-16'
                                                            value={formData.category}
                                                            onChange={handleChange}
                                                        >
                                                            <option value=''>Select a category</option>
                                                            <option value='1'>Mobile Bar</option>
                                                            <option value='2'>Caterer</option>
                                                        </select>
                                                    </div>

                                                    {/* //* business name */}
                                                    <div className='col-12 col-md-12 col-lg-6 col-xl-4 col-xxl-3 mb-3'>
                                                        <label htmlFor='title'>Business Name</label>
                                                        <input
                                                            type='text'
                                                            name='title'
                                                            id='title'
                                                            className='form-control m-0 font-size-16'
                                                            value={formData.title}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* //* phone */}
                                                    <div className='col-12 col-md-12 col-lg-6  col-xl-4 col-xxl-3 mb-3'>
                                                        <label htmlFor='phone'>Phone</label>
                                                        <input
                                                            type='number'
                                                            name='phone'
                                                            id='phone'
                                                            min={0}
                                                            className='form-control m-0 font-size-16'
                                                            value={formData.phone}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* //* email */}
                                                    <div className='col-12 col-md-12 col-lg-6 col-xl-4 col-xxl-3  mb-3'>
                                                        <label htmlFor='email'>Email</label>
                                                        <input
                                                            type='email'
                                                            name='email'
                                                            id='email'
                                                            className='form-control m-0 font-size-16'
                                                            value={formData.email}
                                                            onChange={handleChange}
                                                            disabled
                                                        />
                                                    </div>

                                                    {/* //* location */}
                                                    <div className='col-12 col-md-12 col-lg-12 col-xl-8 col-xxl-6 mb-3'>
                                                        <label htmlFor='location'>Location</label>
                                                        <Select
                                                            id="location"
                                                            name="location"
                                                            placeholder="Select locations"
                                                            options={locationOptions}
                                                            isMulti
                                                            className="basic-multi-select"
                                                            value={locationOptions.filter(opt => formData.location?.includes(opt.value))}
                                                            onChange={(selectedOptions) => {
                                                                handleChange({
                                                                    target: {
                                                                        name: 'location',
                                                                        value: selectedOptions.map(opt => opt.value),
                                                                    },
                                                                })
                                                            }
                                                            }
                                                        />

                                                    </div>

                                                    {/* //* website */}
                                                    <div className='col-12 col-md-12 col-lg-6 col-xl-6 col-xxl-3 mb-3'>
                                                        <label htmlFor='website mb-1'>Website</label>
                                                        <input
                                                            type='text'
                                                            name='website'
                                                            id='website'
                                                            className='form-control m-0'
                                                            placeholder='Enter your wesbite'
                                                            value={formData.website}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* //* insta */}
                                                    <div className='col-12 col-md-12  col-lg-6 col-xl-6 col-xxl-3  mb-3'>
                                                        <label htmlFor='insta'>Instagram</label>
                                                        <input
                                                            type='text'
                                                            name='insta'
                                                            id='insta'
                                                            className='form-control m-0'
                                                            placeholder='Enter your instagram'
                                                            value={formData.insta}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* //* description */}
                                                    <div className='col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-1'>
                                                        <label htmlFor='description'>Description:</label>
                                                        <textarea
                                                            value={formData.description}
                                                            onChange={handleChange}
                                                            className='form-control'
                                                            name='description'
                                                            id='description'
                                                            rows={4}
                                                            placeholder='Enter description (max 300 words)'
                                                        />
                                                        <div className='text-end text-sm text-gray-500 mt-1'>
                                                            {formData.description.trim().split(/\s+/).filter(Boolean).length} / 300 words
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* //* gallery image */}
                                    <div className='col-12'>
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center justify-content-between rounded-2 mb-3 px-3 py-2" style={{ background: '#e8fff4' }}>
                                                    <label htmlFor="email" className="mb-0 fw-semibold">Business Images</label>
                                                </div>

                                                <div
                                                    onClick={handleUploadClick}
                                                    className='d-flex flex-column align-items-center justify-content-center'
                                                    style={{
                                                        border: '2px dashed #aaa',
                                                        borderRadius: '10px',
                                                        padding: '10px',
                                                        textAlign: 'center',
                                                        cursor: 'pointer',
                                                        backgroundColor: '#f9f9f9',
                                                        minHeight: '150px',
                                                    }}
                                                >
                                                    {images.length === ZERO ? (
                                                        <div>
                                                            <strong>Click to upload images.</strong>
                                                            <p className='mb-0'>Upload minimum 3 and maximum 20 images</p>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    flexWrap: 'wrap',
                                                                    gap: '10px',
                                                                    justifyContent: 'center',
                                                                    marginBottom: '10px',
                                                                }}
                                                            >
                                                                {images.map((img, index) => (
                                                                    <div key={index} style={{ position: 'relative' }}>
                                                                        <img
                                                                            src={img.preview}
                                                                            alt='preview'
                                                                            width='100'
                                                                            height='100'
                                                                            style={{ objectFit: 'cover', borderRadius: '8px' }}
                                                                        />
                                                                        <button
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                if (img.id) {
                                                                                    setConfirmationModal(trueValue);
                                                                                    setImageID(img.id);
                                                                                } else {
                                                                                    const updatedImages = images.filter((_, i) => i !== index);
                                                                                    setImages(updatedImages);
                                                                                }
                                                                            }}
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: '-5px',
                                                                                right: '-5px',
                                                                                background: '#c99449',
                                                                                color: 'white',
                                                                                border: 'none',
                                                                                borderRadius: '50%',
                                                                                width: '20px',
                                                                                height: '20px',
                                                                                fontSize: '14px',
                                                                                cursor: 'pointer',
                                                                            }}
                                                                        >
                                                                            ×
                                                                        </button>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className='mt-2'>
                                                                <strong>Click to upload more images</strong>
                                                                <p className="mb-0">You can upload {20 - images.length} more images</p>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>

                                                <input
                                                    type="file"
                                                    multiple
                                                    accept=".jpg,.jpeg,.png,.webp"
                                                    style={{ display: 'none' }}
                                                    ref={fileInputRef}
                                                    onChange={handleImageChange}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* //* services */}
                                    <div className='col-12'>
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="p-6 bg-gray-50 min-h-screen flex flex-col items-center">
                                                    <div className="d-flex align-items-center justify-content-between rounded-2 mb-3 px-3 py-2" style={{ background: '#e8fff4' }}>
                                                        <label htmlFor="email" className="mb-0 fw-semibold">Services</label>
                                                        {(services.length < 5) && (
                                                            <button className="btn btn-success" onClick={handleAddService}>
                                                                Add
                                                            </button>
                                                        )}
                                                    </div>

                                                    <div className="row">
                                                        {services.map((service) => (
                                                            <div key={service.id} className="col-12 col-md-4 col-lg-6 col-xl-4 col-xxl-3 mb-3">
                                                                <div className="bg-white p-6 rounded-lg shadow w-full max-w-lg space-y-4 relative">

                                                                    {/* //* Remove Icon */}
                                                                    {
                                                                        service.length > 1 && (
                                                                            <button
                                                                                className="btn bg-danger close-vendor-btn text-white p-1 rounded-circle"
                                                                                onClick={() => {
                                                                                    if (service.isNew) {
                                                                                        handleRemoveService(service.id);
                                                                                    } else {
                                                                                        setConfirmationModal1(trueValue);
                                                                                        setSerImg(service.id);
                                                                                    }
                                                                                }}
                                                                            >
                                                                                ✕
                                                                            </button>
                                                                        )
                                                                    }


                                                                    <div className="p-3 mb-3">
                                                                        <div
                                                                            style={{
                                                                                position: 'relative',
                                                                                width: '100%',
                                                                                aspectRatio: '4 / 3',
                                                                                marginTop: '6px',
                                                                            }}
                                                                        >
                                                                            <img
                                                                                src={service.image}
                                                                                alt="Service"
                                                                                style={{
                                                                                    width: '100%',
                                                                                    height: '100%',
                                                                                    objectFit: 'cover',
                                                                                    border: '1px solid #ccc',
                                                                                    borderRadius: '8px',
                                                                                    cursor: 'pointer',
                                                                                }}
                                                                                onClick={() => document.getElementById(`upload-photo-${service.id}`).click()}
                                                                            />
                                                                            <label
                                                                                htmlFor={`upload-photo-${service.id}`}
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    top: '-8px',
                                                                                    left: '-10px',
                                                                                    background: '#fff',
                                                                                    borderRadius: '50%',
                                                                                    padding: '3px 6px',
                                                                                    fontSize: '13px',
                                                                                    cursor: 'pointer',
                                                                                    boxShadow: '0 0 5px rgba(0,0,0,0.2)',
                                                                                    transform: 'rotate(254deg)',
                                                                                }}
                                                                            >
                                                                                🖉
                                                                            </label>
                                                                            <input
                                                                                type="file"
                                                                                id={`upload-photo-${service.id}`}
                                                                                style={{ display: 'none' }}
                                                                                accept="image/*"
                                                                                onChange={(e) => handleFileChange(e, service.id)}
                                                                            />
                                                                        </div>

                                                                        <div className="row mt-2">

                                                                            <div className='col-12 col-md-12 col-lg-12 '>
                                                                                <label htmlFor={`Name - ${service.id}`}>Service</label>
                                                                                <input
                                                                                    type="text"
                                                                                    name="service_name"
                                                                                    id={`Name-${service.id}`}
                                                                                    className="form-control m-0 font-size-16"
                                                                                    placeholder="Enter service name"
                                                                                    value={service.service_name || ''}
                                                                                    onChange={(e) => handleInputChange(e, service.id, 'service_name')}
                                                                                />
                                                                            </div>

                                                                            {/* <div className='col-12 col-md-12 col-lg-6 ps-3 ps-md-3'>
                                                                                <label htmlFor={`Price-${service.id}`}>Price (ZAR)</label>
                                                                                <input
                                                                                    type='number'
                                                                                    name='Price'
                                                                                    id={`Price-${service.id}`}
                                                                                    className='form-control m-0 font-size-16'
                                                                                    placeholder='Enter price'
                                                                                    value={service.price}
                                                                                    min={1}
                                                                                    disabled
                                                                                    onChange={(e) => handleInputChange(e, service.id, 'price')}
                                                                                />
                                                                            </div> */}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className='d-flex align-items-center justify-content-end'>
                                    <button className='btn btn-primary' onClick={executeUpdateVendorApi} disabled={disableButton}>
                                        {!loading ? 'Update' : <Loader />}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

        </>
    )
}

export default UpdateVendor;